export enum SpeckleAddAccountAuthStatus {
  NOT_STARTED,
  AUTHENTICATING,
  COMPLETE,
  ERROR,
  POPUP_BLOCKED,
}
